import { render, staticRenderFns } from "./InspectionCard.vue?vue&type=template&id=1681944e&scoped=true&"
import script from "./InspectionCard.vue?vue&type=script&lang=ts&"
export * from "./InspectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCard.vue?vue&type=style&index=0&id=1681944e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681944e",
  null
  
)

export default component.exports